// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__KrUWg","deleteBtn":"styles_deleteBtn__xtPGX","deleteBtnWhite":"styles_deleteBtnWhite__Ydqes","clearButton":"styles_clearButton__oqk5P"};